import { graphql } from "gatsby"
import {
  NavigationDataFragment,
  NavigationSecondaryDataFragment,
} from "../../graphql-types"

export const query = graphql`
  fragment NavigationData on NavigationYamlConnection {
    edges {
      node {
        key
        path
        indicate_active_children
        items {
          key
          path
          indicate_active_children
        }
      }
    }
  }

  fragment NavigationSecondaryData on NavigationSecondaryYamlConnection {
    edges {
      node {
        key
        path
        indicate_active_children
        items {
          key
          path
          indicate_active_children
        }
      }
    }
  }
`

export interface NavigationDataItem {
  key: string
  path: string
  indicateActiveChildren: boolean
  items?: NavigationDataItem[]
}

export default function extractNavigation(
  items: NavigationDataFragment | NavigationSecondaryDataFragment
): NavigationDataItem[] {
  return items.edges
    .map(navDefinition => {
      const item: NavigationDataItem = {
        key: navDefinition.node.key,
        path: navDefinition.node.path,
        indicateActiveChildren: navDefinition.node.indicate_active_children,
      }
      if (navDefinition.node.items) {
        item.items = navDefinition.node.items.map(child => ({
          key: child.key || "",
          path: child.path || "",
          indicateActiveChildren: child.indicate_active_children || false,
        }))
      }
      return item
    })
    .filter(item => !!item.key && !!item.path)
}
